<script setup lang="ts">
  import { computed, ref } from 'vue';
  import { useContact } from '@/composables/useContact';
  import { useJourneyContent } from '@/composables/useJourneyContent';
  import { useUseCaseContent } from '@/composables/useUseCaseContent';

  const { packageSectionData, infoSectionData, heroSectionData, highlightsSectionData, highlightSectionTitle, i18nParams, slug } =
    await useUseCaseContent();
  const { contactData, saveContact } = await useContact();
  const { journeyData } = await useJourneyContent();

  useHead({
    title: heroSectionData.value?.title
  });

  const setI18nParams = useSetI18nParams();
  setI18nParams(i18nParams.value);

  const packageNames = computed(() => (packageSectionData.value ? packageSectionData.value.packages.map((pkg) => pkg.title) : []));

  const selectedPackage = ref();

  const selectPackage = (packageTitle: string) => {
    selectedPackage.value = packageTitle;
  };

  const onSubmit = async (data: any) => {
    await saveContact(data);
  };

  const localePath = useLocalePath();
</script>

<template>
  <main>
    <UseCaseHeroSection
      v-if="heroSectionData"
      :hero-section-data="heroSectionData" />
    <UseCaseHighlightsSection
      :title="highlightSectionTitle"
      :items="highlightsSectionData" />
    <UseCaseInfoSection
      v-if="infoSectionData && infoSectionData.showInfoSection"
      :info-section-data="infoSectionData" />
    <UseCasePackagesSection
      v-if="packageSectionData"
      :package-section-data="packageSectionData"
      :locale-path="localePath"
      :use-case-slug="slug"
      @on-select="(packageTitle: string) => selectPackage(packageTitle)" />
    <JourneySection
      v-if="journeyData"
      :journey-section-data="journeyData" />
    <ContactSection
      v-if="contactData"
      :locale-path="localePath"
      :contact-data="contactData"
      :package-names="packageNames"
      :selected-package="selectedPackage"
      @on-submit="onSubmit" />
  </main>
</template>
